import { mqMin } from '../../breakpoints';

const sharedBase = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: 'primaryText',
  padding: 's24',
  'a, a:hover, a:focus': {
    color: 'primaryText',
  },
  [mqMin.tablet]: {
    padding: 's16',
  },
};

const banner = {
  alert: {
    ...sharedBase,
    backgroundColor: 'red.50',
  },
  notice: {
    ...sharedBase,
    backgroundColor: 'green.20',
  },
  warning: {
    ...sharedBase,
    backgroundColor: 'yellow.10',
  },
  white: {
    ...sharedBase,
    backgroundColor: 'white',
  },
  announcement: {
    ...sharedBase,
    backgroundColor: 'blue.60',
    color: 'white',
    'a, a:hover, a:focus': {
      color: 'white',
    },
    [mqMin.tablet]: {
      borderRadius: '1000px',
      paddingTop: 's8',
      paddingBottom: 's8',
    },
  },
};

export default banner;
